import { BoldTextM, Color, ListBody, ListHead, MediumTextM, Space, TableScroller } from "@enxcs/dap-ui-stratos";
import styled from "styled-components";

export const TableStyled = styled(TableScroller)`
  padding: 0 !important;
  flex: 1 1 auto;
  min-height: 0;
  background-color: transparent;

  padding-bottom: ${Space.V8} !important;
`;

export const TableLayout = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: relative;
  padding-bottom: 16px;
`;

export const PaginationFooter = styled.div`
  flex-shrink: 0;
  display: flex;
  justify-content: center;
`;

export const StyledTableHead = styled(ListHead)`
  border-radius: ${Space.V8} !important;
  background: ${Color.Neutral.V00};
  margin-bottom: ${Space.V8};
  border: none !important;
`;

export const StyledTableBody = styled(ListBody)`
  & [role="row"] {
    min-height: 64px;
    justify-content: center;
    & > div:nth-child(2) {
      background: ${Color.Neutral.V00};
      border-radius: ${Space.V8};
    }
  }
`;
export const TitleStyled = styled(BoldTextM)`
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const RowTextStyled = styled(MediumTextM)`
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
